<template>
  <div class="AdminUserCreate">
    <div class="Toolbar">
      <div class="Toolbar-Left cursorPointer" @click="_onClickGoBack">
        <font-awesome-icon :icon="['fal', 'angle-left']" size="2x" />
        <span class="u-ml10 TextWithIcon name-bold">
          {{ clientGroup.name }}
        </span>
      </div>
    </div>

    <el-row :gutter="20">
      <el-col :span="14" :offset="2">
        <h2>ユーザー作成</h2>
      </el-col>
      <el-col :span="14" :offset="2">
        <!-- Forms -->
        <el-form
          :model="userCreateForm"
          ref="userCreateForm"
          label-width="130px"
        >
          <!-- Name Form -->
          <el-form-item
            label="お名前"
            prop="name"
            :rules="[{ required: true, message: 'お名前は必須の項目です' }]"
          >
            <el-input
              placeholder="名前"
              v-model="userCreateForm.name"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- Role Form -->
          <el-form-item
            label="権限"
            prop="role"
            :rules="[{ required: true, message: '権限は必須の項目です' }]"
          >
            <el-radio-group v-model="userCreateForm.role">
              <el-radio label="CLIENT_USER">通常</el-radio>
              <el-radio label="CLIENT_CONTRIBUTOR">制限あり</el-radio>
            </el-radio-group>
            <div class="notice-text">
              ※制限あり ‥
              注文送信ができません。作成した注文の内容確認を通常ユーザーに出すことができます。
            </div>
          </el-form-item>

          <!-- Email Form -->
          <el-form-item
            label="メールアドレス"
            prop="email"
            :rules="[
              {
                required: true,
                message: 'メールアドレスは必須の項目です',
                trigger: 'blur'
              },
              {
                type: 'email',
                message: 'メールアドレス形式のみ入力してください',
                trigger: 'blur'
              },
              {
                pattern: /^[ A-Za-z0-9-./@_]*$/,
                message: '半角英数字のみ入力してください',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              placeholder="xxx@xxx.com"
              v-model="userCreateForm.email"
              type="email"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- Password Form -->
          <el-form-item
            label="パスワード"
            prop="password"
            id="min-char"
            :rules="[
              {
                required: true,
                message: 'パスワードは必須の項目です',
                trigger: 'blur'
              },
              {
                pattern: /^[ A-Za-z0-9!#$%&()*+,-./<=>?@[\]^_{|}~]*$/,
                message: '半角英数字のみ入力してください',
                trigger: 'blur'
              },
              {
                pattern: /^[ A-Za-z0-9!#$%&()*+,-./<=>?@[\]^_{|}~].{7,}$/,
                message: '8文字以上入力してください',
                trigger: 'click'
              }
            ]"
          >
            <el-input
              placeholder="******"
              v-model="userCreateForm.password"
              class="e-input"
              type="password"
            ></el-input>
            <span class="password-required">最低8文字</span>
          </el-form-item>

          <el-form-item
            v-for="(group, index) in userCreateForm.clientGroups"
            :label="'得意先コード' + (index + 1)"
            :key="group.key"
            :prop="'clientGroup' + index"
          >
            <el-input
              v-model="group.id"
              style="width: 70%; margin-right: 5px;"
            ></el-input
            ><el-button
              v-if="index > 0"
              @click.prevent="removeClientGroupInput(index)"
              >削除</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="addClientGroupInput"
              >得意先コードを追加</el-button
            >
          </el-form-item>

          <!-- Actions -->
          <el-form-item>
            <div class="u-flex">
              <div class="u-flex u-grow">
                <el-button @click="getCancelCreateUserDialog()"
                  >キャンセル</el-button
                >
              </div>
              <div class="u-flex u-grow u-jce">
                <el-button type="primary" @click="getCreateUserDialog()"
                  >作成</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- Dialogs Division -->
    <div class="UserCreateDialog">
      <!-- create user dialog -->
      <el-dialog :visible.sync="createUserDialogVisible" center>
        <span class="dialog-text">ユーザーを作成しますか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel-btn" @click="createUserDialogVisible = false"
            >キャンセル</el-button
          >
          <el-button @click="_onClickCreateUser()" class="blue-text-create"
            >はい</el-button
          >
        </span>
      </el-dialog>
      <!-- cancel create user dialog -->
      <el-dialog :visible.sync="cancelCreateUserDialogVisible" center>
        <span class="dialog-text">作成を中止しますか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="cancel-btn"
            @click="cancelCreateUserDialogVisible = false"
            >キャンセル</el-button
          >
          <el-button
            @click="_onClickCancelCreateUser()"
            class="blue-text-create"
            >はい</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// Usecase Dependencies
import { mapState } from "vuex";
import UserUsecase from "@/usecases/user.usecase";

export default {
  components: {},
  data () {
    return {
      userUsecase: new UserUsecase(),
      userCreateForm: {
        name: "",
        role: "",
        clientGroups: [],
        email: "",
        password: "",
      },
      createUserDialogVisible: false,
      cancelCreateUserDialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
    }),
  },
  mounted () {
    this.userCreateForm.clientGroups = [
      {
        key: Date.now(),
        id: this.clientGroup.id,
      },
    ];
  },
  methods: {
    _onClickGoBack () {
      this.goBack();
    },
    /* to open create user dialog */
    getCreateUserDialog () {
      this.$refs["userCreateForm"].validate(valid => {
        if (valid) {
          this.createUserDialogVisible = true;
        }
      });
    },
    /* to open cancel create user dialog */
    getCancelCreateUserDialog () {
      this.cancelCreateUserDialogVisible = true;
    },
    /* to on click create user */
    async _onClickCreateUser () {
      var message = "";
      let clientGroupID = this.clientGroup.id;
      const loading = this.$loading();
      try {
        // save it
        await this.saveUserInfos();

        // it succeed, so I notify it
        message = "ユーザーを作成しました。";
        this.$notify({ message });

        // transition to client list
        this.$router.push({
          name: "admin/clients/users",
          params: { clientGroupID },
        });
      } catch (err) {
        alert(err.errors[0].message);
        return;
      } finally {
        loading.close();
      }
    },
    /* to create user, save user information */
    async saveUserInfos () {
      this.createUserDialogVisible = false;
      const userCreateParam = {
        name: this.userCreateForm.name,
        role: this.userCreateForm.role,
        clientGroupIds: this.userCreateForm.clientGroups.map(c => c.id),
        email: this.userCreateForm.email,
        password: this.userCreateForm.password,
      };
      const res = await this.userUsecase.createUser({
        UserInput: userCreateParam,
      });

      return res;
    },
    /* to cancel create user go back to client list */
    _onClickCancelCreateUser () {
      this.goBack();
    },
    goBack () {
      const { $router } = this;
      const clientID = this.clientGroup.id;
      $router.push({ name: "admin/clients/users", params: { clientID } });
    },
    removeClientGroupInput (index) {
      if (this.userCreateForm.clientGroups.length > 1) {
        this.userCreateForm.clientGroups.splice(index, 1);
      }
    },
    addClientGroupInput () {
      this.userCreateForm.clientGroups.push({
        key: Date.now(),
        id: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminUserCreate .Toolbar {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-left: 1rem;
}
.AdminUserCreate .Toolbar-Left {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.AdminUserCreate .Toolbar-Center {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.AdminUserCreate .Toolbar-Right {
  flex: 1;
  text-align: right;
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.AdminUserCreate {
  width: 99%;
}
.UserCreateDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.UserCreateDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 5rem;
  padding-top: 4.5rem;
  margin-top: 1rem;
}
.UserCreateDialog .el-dialog__footer {
  margin-top: -0.5rem !important;
}
.UserCreateDialog .el-button {
  border: none;
}
.UserCreateDialog .el-dialog__close {
  display: none;
}
.UserCreateDialog .blue-text-create {
  color: $blue-extra-deep;
}
.UserCreateDialog .el-dialog {
  width: 35% !important;
}
.name-bold {
  width: 500px;
  font-weight: bold;
}
.notice-text {
  font-size: 11.5px;
  color: $text-extra-light-blue;
  line-height: 25px;
}
.password-required {
  color: $red-base;
  float: left;
  margin-left: -5rem;
  margin-top: 2rem;
}
#min-char .el-form-item__error {
  top: 60% !important;
}
</style>
